export const SET_SCROLL_PROGRESS = 'SET_SCROLL_PROGRESS';
export const SET_SCROLL_HEIGHT = 'SET_SCROLL_HEIGHT';
export const SET_GUIDE_TITLE = 'SET_GUIDE_TITLE';
export const SET_TOC_VISIBILITY = 'SET_TOC_VISIBILITY';
export const SET_FORM_SENT = 'SET_FORM_SENT';
export const SET_WINDOW_WIDTH = 'SET_WINDOW_WIDTH';
export const SET_WINDOW_HEIGHT = 'SET_WINDOW_HEIGHT';
